import "./ValidationMessage.scss"

import { FC } from "react"

import Text from "components/Text/Text"

interface IValidationMessageProps {
    type?: "error" | "success"
    className?: string
}

const ValidationMessage: FC<React.PropsWithChildren<IValidationMessageProps>> = ({
    type = "error",
    className,
    children,
}) => {
    return (
        <Text className={`validation-message validation-message--type-${type} ${className}`}
            type="pSmallest"
            role="alert">
            {children}
        </Text>
    )
}

export default ValidationMessage
